import { getCookie, removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, History, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CustomState } from "@store/Store/Reducers/YmmeReducer";
import { TYPOGRAPHY } from "@store/theme/design";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    return {
        makes: state.ymmeReducer.makes,
        models: state.ymmeReducer.models,
        years: state.ymmeReducer.years,
        engines: state.ymmeReducer.engines,
        ymmeActive: state.ymmeReducer.active,
    };
};

const enum fields {
    textFieldValue = "textFieldValue",
}

export interface YmmeValuesDisplayStyles {
    wrapper?: InjectableCss;
    addedText?: TypographyProps;
    ymmeText?: TypographyProps;
}

export const ymmeValuesDisplayStyles: YmmeValuesDisplayStyles = {
    wrapper: {
        css: css`
            margin: 15px 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            font-size: ${TYPOGRAPHY.size.larger};
                        `,
                        css`
                            font-size: ${TYPOGRAPHY.size.xlarge};
                        `,
                        css`
                            font-size: ${TYPOGRAPHY.size.xlarge};
                        `,
                    ],
                    "min",
                )}
        `,
    },
    addedText: {
        as: "span",
        css: css`
            font-weight: normal;
        `,
    },
    ymmeText: {
        as: "span",
        css: css`
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
};

interface OwnProps extends WidgetProps {
    makes: any;
    models: any;
    years: any;
    engines: any;
    ymmeActive: boolean;
    fields: {
        [fields.textFieldValue]: string;
    };
}

type Props = HasHistory & OwnProps;

const YmmeValuesDisplay: React.FC<Props> = ({ makes, models, years, engines, ymmeActive, fields }) => {
    return (
        <>
            {ymmeActive === true ? (
                <StyledWrapper {...ymmeValuesDisplayStyles.wrapper}>
                    <Typography {...ymmeValuesDisplayStyles.addedText}>{fields.textFieldValue}</Typography>
                    <Typography {...ymmeValuesDisplayStyles.ymmeText}>
                        {years.selection} {makes.selection} {models.selection} {engines.selection}
                    </Typography>
                </StyledWrapper>
            ) : (
                <></>
            )}
        </>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.textFieldValue,
            displayName: "Text",
            editorTemplate: "TextField",
            defaultValue: "Search for bus parts",
            fieldType: "Translatable",
            tooltip: "Title that will be displayed next to the YMME selector",
            placeholder: "Widget title",
            isRequired: true,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(YmmeValuesDisplay)),
    definition,
};

export default widgetModule;
